class P10R10Accordion {
  constructor(container, options = {}) {
    this.container = container;
    this.items = container.querySelectorAll(".accordion-box");
    this.images = container.querySelectorAll(".view-image");
    this.allowMultiple = options.allowMultiple || false;
    this._init();
  }

  _init() {
    this.items.forEach((item, index) => {
      const header = item.querySelector(".title-box");
      const content = item.querySelector(".text-box");

      // 默认展开第一个
      if (index == 0) {
        item.classList.add("active");
        content.style.height = content.scrollHeight + "px";
      }

      header.addEventListener("click", () => {
        const isOpen = item.classList.contains("active");

        if (!this.allowMultiple) {
          this.items.forEach((el) => {
            el.classList.remove("active");
            const elContent = el.querySelector(".text-box");
            elContent.style.height = "0";
          });
        }

        if (!isOpen || this.allowMultiple) {
          item.classList.toggle("active");
          if (item.classList.contains("active")) {
            // 展开：设置实际高度
            content.style.height = content.scrollHeight + "px";
            if (this.images) {
              this.images.forEach((el) => {
                el.classList.remove("active");
              });
              this.images[index].classList.add("active");
            }
          } else {
            // 收起：设为 0
            content.style.height = "0";
          }
        }
      });
    });
  }
}

function interpolateArray(arr, n, step) {
  if (!Array.isArray(arr) || arr.length < 2 || n < 1) return arr.slice();

  const result = [];

  for (let i = 0; i < arr.length - 1; i++) {
    const start = arr[i];
    const end = arr[i + 1];
    // const step = (end - start) / (n + 1);

    result.push(start);

    for (let j = 1; j <= n; j++) {
      result.push(Number((start + j * step).toFixed(10))); // 避免精度误差
    }
  }

  result.push(arr[arr.length - 1]);

  return result;
}

function averageAdjacentDiff(arr) {
  if (!Array.isArray(arr) || arr.length < 2) return 0;

  let totalDiff = 0;

  for (let i = 1; i < arr.length; i++) {
    totalDiff += arr[i] - arr[i - 1];
  }

  return totalDiff / (arr.length - 1);
}

function safePlay(video) {
  if (!video) return;

  video.muted = true;
  video.setAttribute("playsinline", "");
  video.setAttribute("webkit-playsinline", "");

  const playPromise = video.play();
  if (playPromise && playPromise.catch) {
    playPromise.catch((err) => {
      console.warn("play() 被阻止：", err);
    });
  }
}

class VideoPlayer {
  constructor(video) {
    this.video = video;
    this.steps = [];
  }

  playToTime(targetTime, callback) {
    const video = this.video;
    const onTimeUpdate = (event) => {
      const currentTime = event.target.currentTime;
      this.steps.push(currentTime);
      if (currentTime >= targetTime) {
        video.pause();
        // video.currentTime = targetTime; // 精准对齐
        video.removeEventListener("timeupdate", onTimeUpdate);
        callback && callback();
      }
    };

    video.addEventListener("timeupdate", onTimeUpdate);
    // video.play();
    safePlay(video);
  }

  reversePlayToTime(targetTime, callback) {
    const video = this.video;
    const avgStep = averageAdjacentDiff(this.steps) / 8;
    const reverseSteps = interpolateArray(this.steps, 7, avgStep).reverse();
    const update = () => {
      const firstStep = reverseSteps[0];
      if (firstStep >= targetTime) {
        video.currentTime = firstStep;
        reverseSteps.shift();
      } else {
        callback && callback();
        this.steps = this.steps.filter((step) => step <= targetTime);
        return;
      }
      requestAnimationFrame(update);
    };

    requestAnimationFrame(update);
  }
}

if (!customElements.get("page-detail-p10r10")) {
  customElements.define(
    "page-detail-p10r10",
    class PageDetailP10r10 extends HTMLElement {
      constructor() {
        super();
        this.$type = this.getAttribute("type");
        this.$mode = this.getAttribute("mode");
        this.$isP10 = this.$mode == "p10";
        this.$isR10 = this.$mode == "r10";
        this.$scrollStep = 0;
        this.$isAnimating = false;
        this.$currentStep = 0;
      }

      getJsonData() {
        const scriptEl = document.getElementById("page-detail-p10r10-data");
        const jsonText = scriptEl.textContent || scriptEl.innerHTML;
        this.$jsonData = JSON.parse(jsonText);
      }

      getPageAffixedHeight() {
        const areas = document.querySelectorAll(".shopify-section-group-header-group");
        let height = 0;
        areas.forEach((area) => {
          height += area.getBoundingClientRect().height;
        });
        return height;
      }

      initVideoFullScreenPlay() {
        const triggerElement = this.querySelector(".play-video-full");
        triggerElement.addEventListener("click", () => {
          const videoUrl = triggerElement.getAttribute("data-url");
          const video = document.createElement("video");
          video.src = videoUrl;
          video.controls = true;
          video.muted = true;
          video.setAttribute("playsinline", "");
          video.setAttribute("webkit-playsinline", "");
          video.classList.add("full-video");
          const maskDom = document.createElement("div");
          maskDom.classList.add("full-video-mask", "animate__animated", "animate__fadeIn");
          document.body.appendChild(maskDom);
          document.body.appendChild(video);
          video.play();
          maskDom.addEventListener("click", () => {
            video.pause();
            document.body.removeChild(video);
            document.body.removeChild(maskDom);
          });
        });
      }

      initAnchorEvents() {
        const spans = this.querySelectorAll("[data-apex-anchor-to]");
        spans.forEach((span) => {
          span.addEventListener("click", (e) => {
            const anchorTarget = span.dataset.apexAnchorTo;
            const anchor = this.querySelector(`[data-apex-anchor="${anchorTarget}"]`);
            anchor.scrollIntoView({ behavior: "smooth" });
          });
        });
      }

      initScrollGradientMask(triggerElement) {
        // return;
        const controller = new ScrollMagic.Controller();
        // 创建一个 Scene，设置 pin 效果
        const scene = new ScrollMagic.Scene({
          triggerElement, // 从这个元素开始触发
          duration: Math.max(900, window.innerHeight),
          triggerHook: 0, // 触发时在视口顶部（0 表示 top，0.5 是中间）
        })
          .setPin(triggerElement) // 固定该元素
          .addTo(controller);

        scene.offset(-this.getPageAffixedHeight()).on("progress", (event) => {
          const progress = event.progress; // 0 ~ 1
          triggerElement.querySelector(".animate_box").style.background = `linear-gradient(to bottom, rgba(255, 255, 255, 0) ${
            (1 - progress - 0.2) * 100
          }%, rgba(255, 255, 255, ${progress}) ${(1 - progress) * 100}%)`;
          triggerElement.querySelector(".text_box").style.opacity = progress;
          triggerElement.querySelector(".text_box").style.transform = `translateY(${(1 - progress) * 100}%)`;
        });
      }

      initContent4() {
        const content4 = this.querySelector(".content_4");
        const points = content4.querySelectorAll(".point-box>[aria-controls]");
        Array.from(points).forEach((point) => {
          const fn = () => {
            // 移除所有active
            content4.querySelector(".point-box .active").classList.remove("active");
            content4.querySelector(".image-box__img.active").classList.remove("active");
            content4.querySelector(".image-box__watch.active").classList.remove("active");
            content4.querySelector(".text-box.active").classList.remove("active");
            const target = point.getAttribute("aria-controls");
            point.classList.add("active");
            const targets = content4.querySelectorAll(`[data-target="${target}"]`);
            Array.from(targets).forEach((target) => {
              target.classList.add("active");
            });
          };
          point.addEventListener("click", fn);
        });
      }

      initContent4Mobile() {
        const images = this.querySelectorAll(".content_4 .image-box__img");
        const textBoxs = this.querySelectorAll(".content_4 .text-box");
        const points = this.querySelectorAll(".content_4 .point-box [aria-controls]");
        const _swiper = new Swiper(".page-detail-p10r10-mobile .content_4 .swiper", {
          loop: true,
          autoplay: true,
          spaceBetween: 12,
          on: {
            slideChange: function () {
              const currentKey = images[this.realIndex].dataset.target;
              textBoxs.forEach((el) => {
                if (el.dataset.target == currentKey) {
                  el.classList.add("active");
                } else {
                  el.classList.remove("active");
                }
              });
              points.forEach((el) => {
                if (el.getAttribute("aria-controls") == currentKey) {
                  el.classList.add("active");
                } else {
                  el.classList.remove("active");
                }
              });
            },
          },
        });
        points.forEach((el) => {
          el.addEventListener("click", () => {
            const currentKey = el.getAttribute("aria-controls");
            const slideIndex = Array.from(images).findIndex((el) => el.dataset.target == currentKey);
            console.log(`🚀 -> PageDetailP10r10 -> el.addEventListener -> slideIndex\n`, slideIndex);
            _swiper.slideToLoop(slideIndex);
          });
        });
      }

      initContent7Accordion() {
        new P10R10Accordion(document.querySelector(".page-detail-p10r10-desktop .content_7"), {
          allowMultiple: false,
        });
      }

      initContent7Swiper() {
        const images = this.querySelectorAll(".page-detail-p10r10-mobile .content_7 .view-image");
        new Swiper(".page-detail-p10r10-mobile .content_7 .swiper", {
          loop: true,
          autoplay: true,
          pagination: {
            el: ".page-detail-p10r10-mobile .content_7 .swiper-pagination",
            type: "custom",
            renderCustom: function (swiper, current, total) {
              return Array.from({ length: total })
                .map(
                  (_, i) =>
                    `<span class="${
                      i + 1 == current ? "swiper-pagination-bullet swiper-pagination-bullet-active" : "swiper-pagination-bullet"
                    }"></span>`
                )
                .join("");
            },
          },
          on: {
            slideChange: function () {
              images.forEach((el) => {
                el.classList.remove("active");
              });
              images[this.realIndex].classList.add("active");
            },
          },
        });
      }

      initContent8Parallax() {
        const triggerElement = this.querySelector(".content_8");
        // 创建一个 Scene，设置 pin 效果
        const scene = new ScrollMagic.Scene({
          triggerElement, // 从这个元素开始触发
          duration: Math.max(1080, window.innerHeight),
          triggerHook: 0, // 触发时在视口顶部（0 表示 top，0.5 是中间）
        }).addTo(this.$controller);

        scene.offset(-this.getPageAffixedHeight()).on("progress", (event) => {
          const progress = event.progress; // 0 ~ 1
          triggerElement.querySelector("img").style.transform = `translateY(${(0 - progress) * 100}%)`;
        });
      }

      initContent9SwiperDesktop() {
        new Swiper(".page-detail-p10r10-desktop .content_9 .swiper", {
          loop: true,
          autoplay: true,
          effect: "fade",
          navigation: {
            nextEl: ".page-detail-p10r10-desktop .content_9 [is=next-button]",
            prevEl: ".page-detail-p10r10-desktop .content_9 [is=prev-button]",
          },
        });
      }

      initContentNormalSwiperMobile(element, perview = 1.2) {
        new Swiper(`${element} .swiper`, {
          loop: true,
          autoplay: true,
          pagination: {
            el: `${element} .swiper-pagination`,
            // clickable: true,
            type: "custom",
            renderCustom: function (swiper, current, total) {
              return Array.from({ length: total })
                .map(
                  (_, i) =>
                    `<span class="${
                      i + 1 == current ? "swiper-pagination-bullet swiper-pagination-bullet-active" : "swiper-pagination-bullet"
                    }"></span>`
                )
                .join("");
            },
          },
          slidesPerView: perview,
          spaceBetween: 12,
        });
      }

      initScrollVideo() {
        const triggerElement = this.querySelector(".content_13 .scroll-animate");
        const video = this.querySelector(".content_13 video");
        const videoPlayer = new VideoPlayer(video);
        const eventHandle = this.$type === "desktop" ? "wheel" : "touchmove";
        let scrollDirection = "FORWARD";
        let scrollStep = 0;
        let isAnimating = false;

        const toggleLighting = (index, clear) => {
          const lightings = triggerElement.querySelectorAll(".lighting");
          lightings.forEach((el) => {
            el.style.display = "none";
          });
          if (clear) {
            return;
          }
          const _thisEl = triggerElement.querySelector(`.lighting.l_${index + 1}`);
          if (_thisEl) {
            const _allInfoEl = triggerElement.querySelectorAll(`.info-box`);
            const _thisInfoEl = triggerElement.querySelector(`.info-box.info_${index + 1}`);
            _allInfoEl.forEach((el) => {
              el.classList.remove("active");
            });
            _thisInfoEl.classList.add("active");
            _thisEl.style.display = "grid";
          }
        };

        const wheelListener = (e) => {
          // 往下滑
          if (scrollDirection !== "FORWARD") {
            return;
          }
          e.preventDefault();
          if (isAnimating) return;
          isAnimating = true;
          if (scrollStep === 0) {
            toggleLighting(scrollStep, true);
            videoPlayer.playToTime(4, () => {
              scrollStep = 1;
              isAnimating = false;
              toggleLighting(scrollStep);
            });
          } else if (scrollStep === 1) {
            toggleLighting(scrollStep, true);
            videoPlayer.playToTime(video.duration, () => {
              scrollStep = 2;
              isAnimating = false;
              toggleLighting(scrollStep);
            });
          } else {
            document.removeEventListener(eventHandle, wheelListener, { passive: false });
            window.scrollTo({
              top: window.scrollY + triggerElement.getBoundingClientRect().height,
              behavior: "smooth",
            });
          }
        };

        video.addEventListener("loadeddata", () => {
          video.currentTime = 1;
        });
        // 创建一个 Scene，设置 pin 效果
        const scene = new ScrollMagic.Scene({
          triggerElement, // 从这个元素开始触发
          duration: triggerElement.getBoundingClientRect().height,
          triggerHook: 0, // 触发时在视口顶部（0 表示 top，0.5 是中间）
        })
          .setPin(triggerElement) // 固定该元素
          .addTo(this.$controller);

        scene
          .offset(-this.getPageAffixedHeight())
          .on("enter", (event) => {
            scrollDirection = event.scrollDirection;
            if (event.scrollDirection === "FORWARD") {
              scrollStep = 0;
              video.currentTime = 1;
              isAnimating = false;
              document.addEventListener(eventHandle, wheelListener, { passive: false });
            }
          })
          .on("leave", (event) => {
            video.pause();
            document.removeEventListener(eventHandle, wheelListener, { passive: false });
            if (event.scrollDirection === "REVERSE") {
              scrollStep = 0;
              video.currentTime = 0;
            } else if (event.scrollDirection === "FORWARD") {
              scrollStep = 2;
              if (video?.currentTime) {
                video.currentTime = video.duration;
              }
            }
            toggleLighting(scrollStep);
          });
      }

      initContent15SwiperDesktop() {
        // const images = this.querySelectorAll(".content_15 .view-image");
        const bullets = this.querySelectorAll(".content_15 .item-pagination [data-swiper-index]");
        const descs = this.querySelectorAll(".content_15 .item-description [data-swiper-index]");
        const itemHeight = this.querySelector(".content_15 .swiper .swiper-slide").getBoundingClientRect().height;
        this.querySelector(".content_15 .swiper").style.height = `${itemHeight}px`;
        const _swiper = new Swiper(".page-detail-p10r10-desktop .content_15 .swiper", {
          // loop: true,
          autoplay: true,
          spaceBetween: 28,
          on: {
            slideChange: function () {
              bullets.forEach((el) => {
                el.classList.remove("active");
              });
              descs.forEach((el) => {
                el.classList.remove("active");
              });
              descs[this.realIndex].classList.add("active");
              bullets[this.realIndex].classList.add("active");
            },
          },
        });
        bullets.forEach((el) => {
          el.addEventListener("click", () => {
            _swiper.slideTo(el.dataset.swiperIndex);
          });
        });
      }

      initContent17Video() {
        const triggerElement = this.querySelector(".content_17");
        const video = triggerElement.querySelector("video");
        const scene = new ScrollMagic.Scene({
          triggerElement: triggerElement, // 从这个元素开始触发
          duration: window.innerHeight,
          triggerHook: 0.5, // 触发时在视口顶部（0 表示 top，0.5 是中间）
        }).addTo(this.$controller);

        scene.on("enter", () => {
          video.currentTime = 0;
          video.play();
        });
      }

      initContent18Accordion() {
        new P10R10Accordion(document.querySelector(".page-detail-p10r10-desktop .content_18"), {
          allowMultiple: false,
        });
      }

      initContent20SwiperDesktop() {
        const wrapper = this.querySelector(".page-detail-p10r10-desktop .content_20 .swiper-wrapper");
        let locked = false;
        const _swiper = new Swiper(".page-detail-p10r10-desktop .content_20 .swiper", {
          virtualTranslate: true,
          initialSlide: 4,
          navigation: {
            nextEl: ".page-detail-p10r10-desktop .content_20 [is=next-button]",
            prevEl: ".page-detail-p10r10-desktop .content_20 [is=prev-button]",
          },
        })
          .on("slideChange", () => {
            if (locked) {
              locked = false;
              return;
            }
            const slides = this.querySelectorAll(".page-detail-p10r10-desktop .content_20 .swiper .swiper-slide");
            if (_swiper.previousIndex < _swiper.activeIndex) {
              //  往后
              wrapper.appendChild(slides[0]);
            } else {
              //  往前
              wrapper.insertBefore(slides[slides.length - 1], slides[0]);
            }
            locked = true;
            _swiper.slideTo(4, 0);
          })
          .on("transitionEnd", () => {
            const currentSlide = this.querySelector(".page-detail-p10r10-desktop .content_20 .swiper .swiper-slide:nth-child(5)");
            const infoBox = this.querySelector(".page-detail-p10r10-desktop .content_20 .info-box");
            const currentData = this.$jsonData.dialData[`dial_${currentSlide.dataset.dial}`];
            infoBox.querySelector("h1").innerHTML = currentData.title;
            infoBox.querySelector("p").innerHTML = currentData.descrition;
          });
      }

      initContent20SwiperMobile() {
        const _swiper = new Swiper(`.page-detail-p10r10-mobile .content_20 .swiper`, {
          loop: true,
          autoplay: true,
          pagination: {
            el: `.page-detail-p10r10-mobile .content_20 .swiper-pagination`,
            type: "custom",
            renderCustom: function (swiper, current, total) {
              return Array.from({ length: total })
                .map(
                  (_, i) =>
                    `<span class="${
                      i + 1 == current ? "swiper-pagination-bullet swiper-pagination-bullet-active" : "swiper-pagination-bullet"
                    }"></span>`
                )
                .join("");
            },
          },
          // initialSlide: 4,
          slidesPerView: 2.6,
          centeredSlides: true,
          spaceBetween: 0,
        }).on("slideChange", () => {
          const currentSlide = _swiper.slides[_swiper.activeIndex];
          const infoBox = this.querySelector(".page-detail-p10r10-mobile .content_20 .info-box");
          const currentData = this.$jsonData.dialData[`dial_${currentSlide.dataset.dial}`];
          infoBox.querySelector("h1").innerHTML = currentData.title;
          infoBox.querySelector("p").innerHTML = currentData.descrition;
        });
      }

      initContentAnimation() {
        const contents = this.querySelectorAll('[class*="content_"]');
        contents.forEach((content) => {
          const scene = new ScrollMagic.Scene({
            triggerElement: content, // 从这个元素开始触发
            duration: window.innerHeight,
            triggerHook: 0.5, // 触发时在视口顶部（0 表示 top，0.5 是中间）
          }).addTo(this.$controller);

          scene.on("enter", (event) => {
            content.classList.add("animate");
          });
          scene.on("progress", (event) => {
            if (event.progress >= 0.5) {
              content.classList.add("animate");
            }
          });
          // scene.on("leave", (event) => {
          //   // content.classList.remove("animate");
          // });
        });
      }

      initContent13Video() {
        const _this = this;
        const triggerElement = this.querySelector(".content_13 .scroll-animate");
        const video = this.querySelector(".content_13 video");
        const stepTimes = [4, video.duration]; // 每步对应的播放时间（秒）
        const totalSteps = stepTimes.length;

        let currentStep = 0;
        let isPlaying = false;
        let scrollLocked = false;
        video.pause();
        video.addEventListener("canplaythrough", () => {
          video.pause();
        });

        // 禁止滚动
        function disableScroll() {
          document.body.style.overflow = "hidden";
          document.body.style["overscroll-behavior"] = "none";
          document.body.style["-webkit-overflow-scrolling"] = "auto";
          if (_this.$type == "desktop") {
            document.body.style.paddingRight = "17px";
          }
          document.addEventListener("touchmove", preventDefault, { passive: false });
          document.addEventListener("wheel", preventDefault, { passive: false });
        }

        function enableScroll() {
          document.body.style.overflow = "";
          document.body.style.paddingRight = "";
          document.body.style["overscroll-behavior"] = "";
          document.body.style["-webkit-overflow-scrolling"] = "";
          document.removeEventListener("touchmove", preventDefault);
          document.removeEventListener("wheel", preventDefault);
        }

        function preventDefault(e) {
          e.preventDefault();
        }

        function playTo(targetTime, callback) {
          if (!video) return;
          isPlaying = true;
          video.play();

          const check = () => {
            if (video.currentTime >= targetTime || video.currentTime >= video.duration) {
              video.pause();
              isPlaying = false;
              callback && callback(video.currentTime >= video.duration);
            } else {
              video.play();
              requestAnimationFrame(check);
            }
          };

          check();
        }

        function onScrollAttempt(e) {
          if (scrollLocked || isPlaying) return;
          if (video.currentTime >= video.duration) {
            enableScroll();
            return;
          }

          scrollLocked = true;
          disableScroll();

          const targetTime = stepTimes[currentStep];
          triggerElement.dataset.progress = currentStep;
          playTo(targetTime, (isEnd) => {
            currentStep++;
            if (currentStep >= totalSteps || isEnd) {
              enableScroll();
            } else {
              disableScroll(); // 等待下一次滚动
            }
            scrollLocked = false;
            triggerElement.dataset.current = currentStep;
          });
        }

        // scene 设置
        const scene = new ScrollMagic.Scene({
          triggerElement: triggerElement,
          duration: window.innerHeight,
          triggerHook: 0,
        })
          .offset(-this.getPageAffixedHeight())
          .setPin(triggerElement)
          .on("enter", (event) => {
            video.currentTime = 0;
            currentStep = 0;
            enableScroll();
            if (event.scrollDirection === "REVERSE") {
              return;
            }
            window.addEventListener("wheel", onScrollAttempt, { passive: false });
            window.addEventListener("touchend", onScrollAttempt, { passive: false });
          })
          .on("leave", () => {
            window.removeEventListener("wheel", onScrollAttempt);
            window.removeEventListener("touchend", onScrollAttempt);
            triggerElement.dataset.progress = "";
            triggerElement.dataset.current = "";
            video.currentTime = 0;
            currentStep = 0;
            isPlaying = false;
            scrollLocked = false;
            enableScroll();
          })
          .addTo(this.$controller);
      }

      initContent13VideoMobile() {
        const triggerElement = this.querySelector(".content_13 .scroll-animate");
        const video = this.querySelector(".content_13 video");
        video.pause();
        // scene 设置
        const scene = new ScrollMagic.Scene({
          triggerElement: triggerElement,
          duration: window.innerHeight,
          triggerHook: 0.5,
        })
          .on("enter", (event) => {
            video.currentTime = 0;
            video.play();
          })
          .addTo(this.$controller);
      }

      initDeskTop() {
        this.initScrollGradientMask(this.querySelector(".page-detail-p10r10-desktop .content_3 .scroll-animate"));
        this.initContent4();
        this.initContent7Accordion();
        this.initContent8Parallax();
        this.$isP10 && this.initContent9SwiperDesktop();
        this.initScrollGradientMask(this.querySelector(".page-detail-p10r10-desktop .content_10 .scroll-animate"));
        this.initScrollGradientMask(this.querySelector(".page-detail-p10r10-desktop .content_12 .scroll-animate"));
        // this.initScrollVideo();
        this.initContent15SwiperDesktop();
        this.initContent18Accordion();
        this.initContent20SwiperDesktop();
        this.initContentAnimation();
        this.$isP10 && this.initContent17Video();
        this.initContent13Video();
      }

      initMobile() {
        // this.initScrollGradientMask(this.querySelector(".content_3 .scroll-animate"));
        this.initContent4Mobile();
        this.initContent7Swiper();
        this.initContentNormalSwiperMobile(".page-detail-p10r10-mobile .content_9");
        // this.initScrollGradientMask(this.querySelector(".page-detail-p10r10-mobile .content_10 .scroll-animate"));
        this.initContentNormalSwiperMobile(".page-detail-p10r10-mobile .content_11");
        // this.initScrollGradientMask(this.querySelector(".page-detail-p10r10-mobile .content_12 .scroll-animate"));
        // this.initScrollVideo();
        this.initContentNormalSwiperMobile(".page-detail-p10r10-mobile .content_15", 1);
        this.initContentNormalSwiperMobile(".page-detail-p10r10-mobile .content_18");
        this.initContent20SwiperMobile();
        this.initContentNormalSwiperMobile(".page-detail-p10r10-mobile .content_21");
        this.$isP10 && this.initContent17Video();
        this.initContent13VideoMobile();
      }

      connectedCallback() {
        window.addEventListener("load", () => {
          // this.$controller = new ScrollMagic.Controller();
          this.getJsonData();
          if (this.$type === "desktop" && window.innerWidth > 1000 && ScrollMagic) {
            this.$controller = new ScrollMagic.Controller();
            this.initDeskTop();
            this.initContentAnimation();
            this.initVideoFullScreenPlay();
            this.initAnchorEvents();
          }
          if (this.$type === "mobile" && window.innerWidth <= 1000 && ScrollMagic) {
            this.$controller = new ScrollMagic.Controller();
            this.initMobile();
            this.initContentAnimation();
            this.initVideoFullScreenPlay();
            this.initAnchorEvents();
          }
        });
      }

      disconnectedCallback() {}
    }
  );
}
